import { Gauge } from 'lucide-react';
import EmBreve from '../components/EmBreve';

/** Módulo Qualidade — placeholder até a implementação (Fase 33). */
export default function Qualidade() {
  return (
    <EmBreve
      titulo="Qualidade"
      subtitulo="Indicadores de qualidade do serviço prestado"
      icone={<Gauge size={24} />}
      descricao="Esta área vai reunir os indicadores de qualidade — sinal, quedas, reincidência de chamados e SLA."
    />
  );
}
